export default "__VITE_ASSET__CCl33_JB__"